import { useQuery } from "@tanstack/react-query";
import classNames from "classnames";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import parse, { domToReact } from "html-react-parser";
import { useContext } from "react";
import CartContext from "../../context/cart";
import UserContext from "../../context/user";
import { translateCart } from "../../utils/lang";
import Icon from "../icon";
import CartCard from "./cart-card";
import AppError from "../app-error";
dayjs.extend(LocalizedFormat);

const CartSummary = ({ variant, readOnly = false, tempCartId }) => {
  const { logged, callApi } = useContext(UserContext);
  const {
    campaign: { cartSelectionEndDate },
    appLang,
    labels,
    setCurrentSectionIndex,
    cartRequest,
  } = useContext(CartContext);

  const cartId = tempCartId ?? cartRequest?.contentId;

  const {
    isFetching,
    error,
    data: cart,
  } = useQuery(["cart-detail", cartId], () => callApi(`/cart/${cartId}`), {
    enabled: logged && !!cartId,
    select: (data) => translateCart(data, appLang),
  });

  const goToCartSelection = () => setCurrentSectionIndex(0);

  const opt = {
    replace: (elem) => {
      if (elem.type === "tag" && elem.name === "button") {
        return (
          <button onClick={goToCartSelection} type="button" className="link link--accent">
            <span>{domToReact(elem.children)}</span>
            <Icon name="pencil" />
          </button>
        );
      }
    },
  };

  return error ? (
    <AppError labels={labels} />
  ) : isFetching ? (
    <div className="loading-spinner mt" />
  ) : (
    <div
      className={classNames(
        "carrello-content__cart-summary",
        variant && `carrello-content__cart-summary--${variant}`
      )}
    >
      <div className="carrello-content__text">
        <strong>
          {variant
            ? {
                confirmation: labels?.WELFARE_CART_SUMMARY_SELECTED || "You selected:",
                default: labels?.WELFARE_CART_SUMMARY_ASSIGNED || "We reserved you the cart:",
                reminder:
                  labels?.WELFARE_CART_SUMMARY_REMINDER ||
                  "Ti ricordiamo che il carrello da te scelto è:",
              }[variant]
            : labels?.WELFARE_CART_SUMMARY || "Your cart:"}
        </strong>
      </div>
      <div className="carrello-content__card-wrapper">
        <CartCard item={cart} />
      </div>
      {!readOnly && (
        <div className="carrello-content__date-info">
          {parse(
            (
              labels?.WELFARE_CARRELLO_EXPIRY_DATE ||
              "You have until [DATE] to <button>change your cart</button>"
            )?.replace(
              "[DATE]",
              dayjs(cartSelectionEndDate).locale(labels?._LANGUAGE).format("LL")
            ),
            opt
          )}
        </div>
      )}
    </div>
  );
};

export default CartSummary;
